function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    Shape\n  ");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "\n    Created with Sketch.\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-206.000000, -490.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  stroke: "#FFFFFF",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M220.461525,502.230771 C220.163762,502.230771 219.923079,502.471455 219.923079,502.76922 L219.923079,504.923073 L208.07695,504.923073 L208.07695,502.76922 C208.07695,502.471455 207.835717,502.230771 207.538475,502.230771 C207.241233,502.230771 207,502.471455 207,502.76922 L207,505.461551 C207,505.759316 207.241233,506 207.538475,506 L220.461525,506 C220.759288,506 221,505.759316 221,505.461551 L221,502.76922 C221,502.471455 220.759288,502.230771 220.461525,502.230771 Z M209.21408,498.314016 L213.574095,502.677134 C213.681248,502.78481 213.821265,502.836502 213.960726,502.835442 C213.979572,502.837058 213.995726,502.846211 214.014572,502.846211 C214.093204,502.846211 214.166418,502.827904 214.233725,502.79775 C214.301571,502.771903 214.366187,502.732596 214.421126,502.677689 L218.784827,498.317415 C218.995381,498.107414 218.995903,497.766583 218.785382,497.556027 C218.680382,497.450489 218.542536,497.397736 218.404152,497.397719 C218.266289,497.397719 218.128999,497.450489 218.02346,497.55495 L214.553083,501.024034 L214.553083,491.538447 C214.553083,491.240676 214.311853,491 214.014606,491 C213.717359,491 213.476128,491.240676 213.476128,491.538447 L213.476128,501.050419 L209.97765,497.554782 C209.872634,497.449243 209.733728,497.395935 209.595882,497.395935 C209.458036,497.395935 209.321267,497.44815 209.216267,497.552612 C209.004669,497.762091 209.004131,498.103476 209.21413,498.313999 L209.21408,498.314016 Z"
})));

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17"
  }, props), _ref, _ref2, _ref3);
}

export default SvgDownload;